import React from 'react';
import { FajitaForms } from './FajitaForms';

export const FajitaIntro = () => <FajitaForms />;
